import { shouldRefreshToken, refreshAccessToken, clearTokens } from './authClient';

export async function apiFetch(url, options = {}) {
    // Proactive refresh if token expiring soon
    if (shouldRefreshToken()) {
        await refreshAccessToken();
    }

    const token = localStorage.getItem('clientToken');
    const response = await fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${token}`
        }
    });

    // Handle 401 - token expired before we could refresh
    if (response.status === 401) {
        // Disabled account: no refresh, straight out with the reason
        const body = await response.clone().json().catch(() => ({}));
        if (body.error === 'Account disabled') {
            clearTokens();
            window.location.href = '/client/login?disabled=true';
            throw new Error('Account disabled');
        }
        // One more refresh attempt
        const refreshed = await refreshAccessToken();
        if (refreshed) {
            // Retry with new token
            const newToken = localStorage.getItem('clientToken');
            return fetch(url, {
                ...options,
                headers: {
                    ...options.headers,
                    'Authorization': `Bearer ${newToken}`
                }
            });
        } else {
            // Refresh failed - session truly expired
            clearTokens();
            window.location.href = '/client/login?expired=true';
            throw new Error('Session expired');
        }
    }

    return response;
}
